import { useState } from "react";
import { useTranslate } from "@refinedev/core";

export function useAgreementForm() {
  const [activeStep, setActiveStep] = useState(0);
  const translate = useTranslate();

  const steps = [
    translate("flux.steps.register"),
    translate("flux.steps.modules"),
    translate("flux.steps.whiteLabel"),
    translate("flux.steps.integrations"),
    translate("flux.steps.legal")
  ];

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleStep = (step: number) => () => {
    setActiveStep(step);
  };

  const handleSubmit = (onSubmit: () => void) => {
    if (activeStep === steps.length - 1) {
      onSubmit();
    } else {
      handleNext();
    }
  };

  return {
    steps,
    activeStep,
    handleStep,
    handleNext,
    handleBack,
    handleSubmit,
    isLastStep: activeStep === steps.length - 1,
  };
}
